import { useEffect } from "react";

export default function useDebouncedEffect(
  fn: () => void,
  delay: number,
  // eslint-disable-next-line
  deps?: any[],
) {
  useEffect(() => {
    // Set debouncedValue to value (passed in) after the specified delay
    const handler = setTimeout(fn, delay);

    return () => {
      clearTimeout(handler);
    };
    // eslint-disable-next-line
  }, deps);
}
